import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (

        <>
            <Helmet>
                <title>
                    Hotels in Dubai | South Travels Hotels
                </title>

                <meta
                    name="description"
                    content="Browse luxury hotels, beachfront resorts, family stays, and premium accommodations in Dubai with South Travels Hotels."
                />

                <link
                    rel="canonical"
                    href="https://hotel.southtravels.com/hotels"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Hotels in Dubai | South Travels Hotels"
                />

                <meta
                    property="og:description"
                    content="Browse luxury hotels, beachfront resorts, family stays, and premium accommodations in Dubai with South Travels Hotels."
                />

                <meta
                    property="og:url"
                    content="https://hotel.southtravels.com/hotels"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in Dubai | South Travels Hotels"
                />

                <meta
                    name="twitter:description"
                    content="Browse luxury hotels, beachfront resorts, family stays, and premium accommodations in Dubai with South Travels Hotels."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />
            </Helmet>


            <div>
                <HotelList showSidebar={true} showBanner={true} showHeading={false} />
            </div>
        </>
    );
}